import { Stack, Text, Heading } from 'braid-design-system';
import React from 'react';

import Carousel from 'src/components/Carousel/Carousel';

import Section from '../../components/Section/Section';

import CarouselCard from './components/CarouselCard/CarouselCard';
import { alliances } from './data';

const carouselCards = () =>
  alliances().map((card, index) => (
    <CarouselCard key={index} htag={`alliances-item-${index}`} {...card} />
  ));

const Alliances = () => (
  <Section>
    <Stack space="medium">
      <Heading level="2">Leadership and community</Heading>
      <Text>
        SEEK Business is committed to improving our industry and fostering best
        practices so that both franchisors and franchisees benefit. We often run
        joint events with the following industry leaders to facilitate
        networking and learning that will benefit the whole franchising
        community.
      </Text>
      <Carousel
        show={{ mobile: 3, tablet: 3, desktop: 3, wide: 3 }}
        maxSlides={3}
      >
        {carouselCards()}
      </Carousel>
    </Stack>
  </Section>
);

export default Alliances;
